import React from "react";

interface CarouselHeaderProps {
  title: string | React.ReactNode;
  subtitle?: string;
  className?: string;
}

const CarouselHeader: React.FC<CarouselHeaderProps> = ({
  title,
  subtitle,
  className = "",
}) => {
  return (
    <div className={`text-left mb-6 ${className}`}>
      {typeof title === "string" ? (
        <h2 className="text-display2 mb-2">{title}</h2>
      ) : (
        <h2 className="text-display2 mb-2">{title}</h2>
      )}
      {subtitle ? (
        <p className="text-body2 text-neutral-base mt-2">{subtitle}</p>
      ) : null}
    </div>
  );
};

export default CarouselHeader;
